<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_xxi"></a>NOTE ON SPELLING AND ORTHOGRAPHY</h2>
<p class="normal">All vowels in Lulogooli are pure, pronounced as in Latin vowels. With diphthongs, the affected vowels are spelled out. Some consonants have various spellings related to tongue and teeth placement. For example, “z” is spelled as “z,” “dz,” or “ts.” The spelling for a lapped “l” is either “l” or “r.” These spellings are ignored when I directly quote poems from hymnals. I tried to leave the spelling of the poetry as intact as possible. Thus the word for peace is spelled “mirembe” or “milembe” depending on the hymnal source. “G” is pronounced either soft—close to a “j”—or hard—as in the English word “give.” In most cases, if it is followed by an “i” it will be soft. An apostrophe after a “g” indicates that it is nasalized as in the English word “sing.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// note_spelling.vue?0d35fb6b